<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<lib-page-layout title="Inscription Seule">
  <div class="mb-6">
    <p class="font-bold text-sm mb-4">Choix du pass</p>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      @for (pass of passes; track pass.id) {
      <div
        (click)="selectRoom(pass.id)"
        class="relative cursor-pointer rounded-2xl p-4 flex flex-col gap-2 transition-all border-[2px]"
        [ngClass]="{
        'bg-age-green text-white border-age-green':
          registrationForm.get('pass')?.value === pass.id,
        'bg-age-price-bg text-age-green border-age-price-b':
          registrationForm.get('pass')?.value !== pass.id
      }"
      >
        <div
          class="absolute top-3 left-3 w-5 h-5 rounded-full flex items-center justify-center"
          [ngClass]="{
          'bg-white text-age-green':
            registrationForm.get('pass')?.value === pass.id,
          'border border-age-gold !bg-white':
            registrationForm.get('pass')?.value !== pass.id
        }"
        >
          @if (registrationForm.get('pass')?.value === pass.id) { ✓ }
        </div>

        <div class="mt-4 text-center">
          <p class="text-[24px] font-bold">Pass</p>
          <p class="text-[24px] font-bold mb-3">
            {{ pass.id === 'PASS_1' ? '3 jours' : 'journée'}}
          </p>
          <p class="text-sm opacity-80">{{ pass.period }}</p>
        </div>

        <!-- <p class="mt-2 text-center font-bold text-lg">
          {{ pack.price | number : '' : 'fr-FR'}} DH
        </p> -->
      </div>
      }
    </div>
  </div>
  <form
    [formGroup]="registrationForm"
    (ngSubmit)="onSubmit()"
    class="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6"
  >
    <lib-form-field
      label="Nom"
      placeholder="Votre nom"
      [control]="registrationForm.controls.familyName"
    >
    </lib-form-field>
    <lib-form-field
      label="Prénom"
      placeholder="Votre prénon"
      [control]="registrationForm.controls.firstName"
    >
    </lib-form-field>
    <lib-form-select
      label="Profession"
      [options]="professions"
      [control]="registrationForm.controls.profession"
    ></lib-form-select>
    <lib-form-field
      label="Spécialité"
      placeholder="Votre spécialité"
      [control]="registrationForm.controls.speciality"
    >
    </lib-form-field>
    <lib-form-field
      label="Numéro de téléphone"
      placeholder="+212 6 XX XX XX XX"
      type="tel"
      [control]="registrationForm.controls.phoneNumber"
    ></lib-form-field>
    <lib-form-field
      label="Adresse email"
      placeholder="votre.email@exemple.com"
      type="email"
      [control]="registrationForm.controls.email"
    ></lib-form-field>
    <lib-form-field
      label="Ville"
      placeholder="Votre ville"
      [control]="registrationForm.controls.city"
    ></lib-form-field>
    <lib-form-field
      label="Pays"
      placeholder="Votre pays"
      [control]="registrationForm.controls.country"
    ></lib-form-field>
    <lib-form-textarea
      label="Remarques ou demandes particulières (facultatif)"
      class="col-span-1 md:col-span-2"
      placeholder="Votre message"
      [control]="registrationForm.controls.comment"
    ></lib-form-textarea>
    <div
      class="col-span-1 md:col-span-2 mt-8 pt-8 border-t border-age-brown flex flex-col md:flex-row justify-between items-center gap-6"
    >
      <div class="flex flex-col items-center md:items-start">
        <span class="text-sm font-bold text-gray-600 mb-1">Total à payer</span>
        <span class="font-bebas text-5xl text-age-green leading-none"
          >{{ totalAmount() | number : '' : 'fr-FR' }} DH</span
        >
      </div>

      <div class="flex gap-4 w-full md:w-auto">
        <button
          type="button"
          (click)="onCancel()"
          class="flex-1 md:flex-none border border-age-green rounded-lg px-8 py-3 font-bold text-age-green hover:bg-gray-50 transition-colors cursor-pointer"
        >
          Annuler
        </button>

        <button
          type="submit"
          [disabled]="isSubmitting()"
          class="flex-1 md:flex-none bg-age-green text-white rounded-lg px-8 py-3 font-bold shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-all cursor-pointer"
        >
          @if (!isSubmitting()) { Valider }@else {
          <span class="rounded-full animate-spin"></span>
          <span>Traitement...</span>
          }
        </button>
      </div>
    </div>
  </form>
</lib-page-layout>
